import React, { useState } from "react";
import {
    Box,
    Container,
    Typography,
    TextField,
    Button,
    InputAdornment,
    Paper,
    Stack,
} from "@mui/material";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailIcon from '@mui/icons-material/Email';
import { MascaraTelefone } from "../../../../utils/MascaraTelefone";
import axios from 'axios'
import AlertSuccess from "../../../components/AlertSuccess";



export default function FormularioNichos({ nicho }) {

    const [nome, setNome] = useState("");
    const [email, setEmail] = useState("");
    const [telefone, setTelefone] = useState("");
    const [msgErro, setMsgErro] = useState(false);
    const [open, setOpen] = useState(false)
    const [openSnackbarSuccess, setOpenSnackbarSuccess] = useState(false)
    const [mensagem, setMensagem] = useState("")

    const handleSubmit = async () => {
        if (!nome || !email || !telefone) {
            setMsgErro("Por favor, preencha todos os campos.");
            return;
        } else {
            setMsgErro(false)
        }

        if (telefone.replace(/\D/g, "").length < 11) {
            setMsgErro("Por favor, insira um número de WhatsApp válido.");
            return;
        }

        try {
            setOpen(true);
            await axios.post(`${process.env.REACT_APP_API_URL}/receberFormularioLeadNichos`, {
                nome,
                email,
                nicho,
                telefone,
            });

            // Envia evento Lead para o Meta Pixel
            if (typeof window.fbq !== "undefined") {
                console.log("Rastreando evento Lead no Facebook Pixel");

                window.fbq("track", "Lead", {
                    content_name: "FormularioContato",
                    content_category: nicho,
                    contact_method: "mensagem"
                });
            }
            // Envia evento para o Google via dataLayer
            if (typeof window.dataLayer !== "undefined") {
                window.dataLayer.push({
                    event: 'lead_form_submitted',
                    page_type: window.location.pathname.split('/')[1] || 'home'
                });
            }

            setOpen(false)
            setMensagem("Formulário enviado! Em breve entraremos em contato.")
            setOpenSnackbarSuccess(true);

            setEmail("")
            setNome("")
            setTelefone("")
        } catch (err) {
            setMsgErro("Ocorreu um erro ao enviar o formulário. Por favor, tente novamente.");
            setOpen(false);
        }
    }

    return (
        <>
            {/* FORMULÁRIO */}
            <Box
                sx={{
                    py: { xs: 10, md: 14 },
                    background: "#050505",
                    position: "relative",
                    overflow: "hidden",
                }}
            >
                {/* Glow Roxo */}
                <Box
                    sx={{
                        position: "absolute",
                        width: 500,
                        height: 500,
                        borderRadius: "50%",
                        background: "#9C01B9",
                        opacity: 0.15,
                        filter: "blur(180px)",
                        top: -250,
                        left: -250,
                    }}
                />

                {/* Glow Verde */}
                <Box
                    sx={{
                        position: "absolute",
                        width: 450,
                        height: 450,
                        borderRadius: "50%",
                        background: "#1EFF86",
                        opacity: 0.08,
                        filter: "blur(180px)",
                        bottom: -250,
                        right: -250,
                    }}
                />

                <Container maxWidth="md">
                    <Paper
                        elevation={0}
                        sx={{
                            p: { xs: 4, md: 6 },
                            borderRadius: "32px",
                            background: "rgba(255,255,255,0.05)",
                            backdropFilter: "blur(30px)",
                            border: "1px solid rgba(255,255,255,0.08)",
                            position: "relative",
                            zIndex: 2,
                        }}
                    >
                        {/* Badge */}
                        <Box
                            sx={{
                                width: "fit-content",
                                mx: "auto",
                                mb: 3,
                                px: 2,
                                py: 1,
                                borderRadius: "999px",
                                background: "rgba(30,255,134,0.1)",
                                border: "1px solid rgba(30,255,134,0.15)",
                            }}
                        >
                            <Typography
                                sx={{
                                    color: "#1EFF86",
                                    fontWeight: 700,
                                    fontSize: 13,
                                    letterSpacing: 1,
                                }}
                            >
                                ANÁLISE CONTBLACK
                            </Typography>
                        </Box>

                        {/* Headline */}
                        <Typography
                            sx={{
                                color: "#FFF",
                                textAlign: "center",
                                fontWeight: 900,
                                lineHeight: 1.1,
                                mb: 2,
                                fontSize: {
                                    xs: "2rem",
                                    md: "3rem",
                                },
                            }}
                        >
                            Descubra a melhor estrutura
                            tributária para sua atividade
                        </Typography>

                        <Typography
                            sx={{
                                color: "rgba(255,255,255,0.75)",
                                textAlign: "center",
                                mb: 5,
                                maxWidth: 700,
                                mx: "auto",
                                lineHeight: 1.8,
                            }}
                        >
                            Preencha seus dados e receba uma análise inicial com um
                            especialista da Contblack.
                        </Typography>

                        {/* Benefícios */}
                        <Stack
                            spacing={1.5}
                            sx={{
                                mb: 5,
                                maxWidth: 500,
                                mx: "auto",
                            }}
                        >
                            {[
                                nicho === "Economize" ? "Primeira consulta gratuita com nossos especialistas" : "Análise gratuita da sua situação atual",
                                "Atendimento especializado para o seu nicho",
                                nicho === "Economize" ? "Sigilo e confidencialidade das suas informações" : "Diagnóstico tributário personalizado",
                            ].map((item) => (
                                <Stack
                                    key={item}
                                    direction="row"
                                    spacing={1.5}
                                    alignItems="center"
                                >
                                    <CheckCircleIcon
                                        sx={{
                                            color: "#1EFF86",
                                        }}
                                    />

                                    <Typography
                                        sx={{
                                            color: "#FFF",
                                        }}
                                    >
                                        {item}
                                    </Typography>
                                </Stack>
                            ))}
                        </Stack>

                        {/* Form */}
                        <Stack spacing={2.5}>
                            <TextField
                                name="nome"
                                placeholder="Seu nome"
                                size="large"
                                value={nome}
                                onChange={(e) => {
                                    const value = e.target.value.replace(/[^A-Za-zÀ-ÿ\s]/g, "");
                                    setNome(value);
                                }}
                                fullWidth
                                variant="outlined"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <PersonOutlineIcon
                                                sx={{
                                                    color: "rgba(255,255,255,0.45)"
                                                }}
                                            />
                                        </InputAdornment>
                                    )
                                }}
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: "14px",
                                        background: "rgba(255,255,255,0.04)",
                                        color: "#FFF",

                                        "& fieldset": {
                                            borderColor: "rgba(255,255,255,0.08)"
                                        },

                                        "&:hover fieldset": {
                                            borderColor: "#00E676"
                                        },

                                        "&.Mui-focused fieldset": {
                                            borderColor: "#00E676"
                                        }
                                    },

                                    "& input::placeholder": {
                                        color: "rgba(255,255,255,0.5)",
                                        opacity: 1
                                    }
                                }}
                            />

                            <TextField
                                name="WhatsApp"
                                placeholder="Seu WhatsApp"
                                size="large"
                                value={telefone}
                                onChange={(e) => {
                                    setTelefone(MascaraTelefone(e.target.value));
                                }}
                                fullWidth
                                variant="outlined"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <WhatsAppIcon
                                                sx={{
                                                    color: "rgba(255,255,255,0.45)"
                                                }}
                                            />
                                        </InputAdornment>
                                    )
                                }}
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: "14px",
                                        background: "rgba(255,255,255,0.04)",
                                        color: "#FFF",

                                        "& fieldset": {
                                            borderColor: "rgba(255,255,255,0.08)"
                                        },

                                        "&:hover fieldset": {
                                            borderColor: "#00E676"
                                        },

                                        "&.Mui-focused fieldset": {
                                            borderColor: "#00E676"
                                        }
                                    },

                                    "& input::placeholder": {
                                        color: "rgba(255,255,255,0.5)",
                                        opacity: 1
                                    }
                                }}
                            />

                            <TextField
                                name="E-mail"
                                placeholder="Seu e-mail"
                                size="large"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                fullWidth
                                variant="outlined"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <EmailIcon
                                                sx={{
                                                    color: "rgba(255,255,255,0.45)"
                                                }}
                                            />
                                        </InputAdornment>
                                    )
                                }}
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: "14px",
                                        background: "rgba(255,255,255,0.04)",
                                        color: "#FFF",

                                        "& fieldset": {
                                            borderColor: "rgba(255,255,255,0.08)"
                                        },

                                        "&:hover fieldset": {
                                            borderColor: "#00E676"
                                        },

                                        "&.Mui-focused fieldset": {
                                            borderColor: "#00E676"
                                        }
                                    },

                                    "& input::placeholder": {
                                        color: "rgba(255,255,255,0.5)",
                                        opacity: 1
                                    }
                                }}
                            />
                            {msgErro && (
                                <Typography
                                    sx={{ color: "#FF1744", fontSize: ".9rem", mt: 1 }}
                                >
                                    {msgErro}
                                </Typography>
                            )}

                            <Button
                                size="large"
                                disabled={open ? true : false}
                                sx={{
                                    py: 2,
                                    borderRadius: "16px",
                                    fontWeight: 800,
                                    fontSize: "1rem",
                                    textTransform: "none",
                                    background:
                                        "linear-gradient(135deg,#1EFF86,#00D46A)",
                                    color: "#000",
                                    boxShadow:
                                        "0 20px 50px rgba(30,255,134,0.25)",

                                    "&:hover": {
                                        transform: "translateY(-2px)",
                                        boxShadow:
                                            "0 30px 60px rgba(30,255,134,0.35)",
                                    },
                                }}
                                onClick={handleSubmit}
                            >
                                {open ? "Enviando..." : "Quero agendar minha análise gratuita"}
                            </Button>
                        </Stack>

                        {/* Trust */}
                        <Typography
                            sx={{
                                mt: 3,
                                textAlign: "center",
                                color: "rgba(255,255,255,0.55)",
                                fontSize: ".9rem",
                            }}
                        >
                            Seus dados estão protegidos e serão utilizados apenas
                            para contato comercial conforme a LGPD.
                        </Typography>
                    </Paper>
                </Container>
            </Box>
            <AlertSuccess setOpenSnackbarSuccess={setOpenSnackbarSuccess} openSnackbarSuccess={openSnackbarSuccess} mensagem={mensagem} />
        </>
    )
}